import {EResellerIds, useGetTenantDataQuery} from 'src/containers/User';

enum ELinkType {
  DOCS = 'DOCS',
  SUPPORT_EMAIL = 'SUPPORT_EMAIL',
  PULSE_API = 'PULSE_API',
  FBM_VERIFICATION = 'FBM_VERIFICATION',
  IOS_URGENCY_LEVEL = 'IOS_URGENCY_LEVEL',
  INTEGRATION_PUSH = 'INTEGRATION_PUSH',
  INTEGRATION_WA = 'INTEGRATION_WA',
  CHANNEL_QUALITY_WA = 'CHANNEL_QUALITY_WA',
  FB_PUBLIC_TERMS = 'FB_PUBLIC_TERMS',
  RELEASE = 'RELEASE',
  ERROR_CODES = 'ERROR_CODES',
  WABA_BLOCK = 'WABA_BLOCK',
  WA_CHANNEL_VERIFICATION = 'WA_CHANNEL_VERIFICATION',
  WA_TEMPLATE_MESSAGES = 'WA_TEMPLATE_MESSAGES',
  WA_MM_API = 'WA_MM_API',
  WA_BUSINESS_PORTFOLIO = 'WA_BUSINESS_PORTFOLIO',
  WA_MM_API_ACCEPTANCE = 'WA_MM_API_ACCEPTANCE',
  AGENT_DOCS = 'AGENT_DOCS',
  SMS_PRICING = 'SMS_PRICING',
  SIGN_UP_TERMS = 'SIGN_UP_TERMS',
  BROADCASTS_TUTORIAL = 'BROADCASTS_TUTORIAL',
  TRIGGERS_TUTORIAL = 'TRIGGERS_TUTORIAL',
  CASCADES_TUTORIAL = 'CASCADES_TUTORIAL',
  DIALOGS_TUTORIAL = 'DIALOGS_TUTORIAL',
  MAX_BLOCKING_PROTECTION = 'MAX_BLOCKING_PROTECTION',
}

type TLinks = Record<ELinkType, string>;

const LINKS_OSK: TLinks = {
  [ELinkType.DOCS]: 'https://docs-pulse.edna.ru/',
  [ELinkType.SUPPORT_EMAIL]: 'support@edna.ru',
  [ELinkType.PULSE_API]: 'https://docs-pulse.edna.ru/docs/start/whatis',
  [ELinkType.FBM_VERIFICATION]:
    'https://docs-pulse.edna.ru/docs/additional-info/whatsapp/company-verify',
  [ELinkType.IOS_URGENCY_LEVEL]:
    'https://docs-pulse.edna.ru/docs/additional-info/push/interruption-ios',
  [ELinkType.INTEGRATION_PUSH]: 'https://docs-pulse.edna.ru/docs/channel/push/channel-push-connect',
  [ELinkType.INTEGRATION_WA]: 'https://docs-pulse.edna.ru/docs/api/index',
  [ELinkType.CHANNEL_QUALITY_WA]:
    'https://docs-pulse.edna.ru/docs/additional-info/whatsapp/channel-quality',
  [ELinkType.FB_PUBLIC_TERMS]: 'https://edna.ru/legal/other/whatsapp-connection-conditions',
  [ELinkType.RELEASE]: 'https://docs-pulse.edna.ru/blog',
  [ELinkType.ERROR_CODES]:
    'https://docs-pulse.edna.ru/docs/api/messages/errorcodes#коды-ошибок-при-отправке-сообщений',
  [ELinkType.WABA_BLOCK]: 'https://docs-pulse.edna.ru/docs/additional-info/whatsapp/avoid-block',
  [ELinkType.AGENT_DOCS]: 'https://able-dog-023.notion.site/24f5e4ddaf1180599dc8c40207635bc5',
  [ELinkType.WA_CHANNEL_VERIFICATION]:
    'https://docs-pulse.edna.ru/docs/additional-info/whatsapp/company-verify',
  [ELinkType.WA_MM_API]:
    'https://edna.ru/news/podorozhanie-v-whatsapp-pochemu-vazhno-podklyuchit-mm-api-uzhe-sejchas-i-kak-eto-sdelat/',
  [ELinkType.WA_MM_API_ACCEPTANCE]:
    'https://docs-pulse.edna.ru/docs/additional-info/whatsapp/mm-api-activation#how-to-enable-marketing-messages-api',
  [ELinkType.WA_BUSINESS_PORTFOLIO]:
    'https://docs-pulse.edna.ru/docs/additional-info/whatsapp/business-portfolio',
  [ELinkType.SMS_PRICING]: 'https://edna.ru/sms_pricing_edna/',
  [ELinkType.WA_TEMPLATE_MESSAGES]:
    'https://docs-pulse.edna.ru/docs/additional-info/whatsapp/waba-template',
  [ELinkType.SIGN_UP_TERMS]: 'https://edna.ru/legal/prepaid/offer/',
  [ELinkType.BROADCASTS_TUTORIAL]: 'https://docs-pulse.edna.ru/docs/broadcast/create-broadcast',
  [ELinkType.TRIGGERS_TUTORIAL]: 'https://docs-pulse.edna.ru/docs/scripts/script-using',
  [ELinkType.CASCADES_TUTORIAL]: 'https://docs-pulse.edna.ru/docs/cascades/createcascade',
  [ELinkType.DIALOGS_TUTORIAL]: 'https://docs-pulse.edna.ru/docs/conversations',
  [ELinkType.MAX_BLOCKING_PROTECTION]: 'https://docs-pulse.edna.ru/docs/channel/max/max-guidelines',
};

const LINKS_MFM: TLinks = {
  [ELinkType.DOCS]: 'https://docs-pulse.edna.io/',
  [ELinkType.SUPPORT_EMAIL]: 'support@edna.io',
  [ELinkType.PULSE_API]: 'https://docs-pulse.edna.io/docs/start/whatis',
  [ELinkType.FBM_VERIFICATION]:
    'https://docs-pulse.edna.io/docs/additional-info/whatsapp/company-verify',
  [ELinkType.IOS_URGENCY_LEVEL]: 'https://docs-pulse.edna.io/docs/channel/',
  [ELinkType.INTEGRATION_PUSH]: 'https://docs-pulse.edna.io/docs/channel/',
  [ELinkType.INTEGRATION_WA]: 'https://docs-pulse.edna.io/docs/api/index',
  [ELinkType.CHANNEL_QUALITY_WA]:
    'https://docs-pulse.edna.io/docs/additional-info/whatsapp/channel-quality',
  [ELinkType.FB_PUBLIC_TERMS]: 'https://edna.io/company/legal/whatsapp-connection-conditions',
  [ELinkType.RELEASE]: 'https://docs-pulse.edna.io/blog',
  [ELinkType.ERROR_CODES]:
    'https://docs-pulse.edna.io/docs/api/messages/errorcodes#errors-when-receiving-message-statuses',
  [ELinkType.WABA_BLOCK]: 'https://docs-pulse.edna.io/docs/additional-info/whatsapp/avoid-block',
  [ELinkType.WA_CHANNEL_VERIFICATION]:
    'https://docs-pulse.edna.io/docs/additional-info/whatsapp/company-verify',
  [ELinkType.AGENT_DOCS]: LINKS_OSK[ELinkType.AGENT_DOCS],
  [ELinkType.WA_MM_API]:
    'https://edna.io/resources/whatsapp-price-increase-why-its-important-to-connect-mm-api-now-and-how-to-do-it/',
  [ELinkType.WA_MM_API_ACCEPTANCE]:
    'https://docs-pulse.edna.io/docs/additional-info/whatsapp/mm-api-activation#how-to-enable-marketing-messages-api',
  [ELinkType.WA_BUSINESS_PORTFOLIO]:
    'https://docs-pulse.edna.io/docs/additional-info/whatsapp/business-portfolio/',
  [ELinkType.SMS_PRICING]: LINKS_OSK[ELinkType.SMS_PRICING],
  [ELinkType.WA_TEMPLATE_MESSAGES]:
    'https://docs-pulse.edna.io/docs/additional-info/whatsapp/waba-template',
  [ELinkType.SIGN_UP_TERMS]: 'https://edna.io/company/legal/terms-and-conditions',
  [ELinkType.BROADCASTS_TUTORIAL]: 'https://docs-pulse.edna.io/docs/broadcast/create-broadcast',
  [ELinkType.TRIGGERS_TUTORIAL]: 'https://docs-pulse.edna.io/docs/scripts/script-using',
  [ELinkType.CASCADES_TUTORIAL]: 'https://docs-pulse.edna.io/docs/cascades/createcascade',
  [ELinkType.DIALOGS_TUTORIAL]: 'https://docs-pulse.edna.io/docs/conversations',
  [ELinkType.MAX_BLOCKING_PROTECTION]: '',
};

const LINKS_PT: TLinks = {...LINKS_MFM};

const LINKS_BLR: TLinks = {
  ...LINKS_OSK,
  [ELinkType.DOCS]: 'https://docs-pulse.edna.by/',
  [ELinkType.SUPPORT_EMAIL]: 'support@edna.by',
  [ELinkType.PULSE_API]: 'https://docs-pulse.edna.by/docs/start/whatis',
  [ELinkType.FBM_VERIFICATION]: 'https://docs-pulse.edna.by/docs/channel',
  [ELinkType.IOS_URGENCY_LEVEL]: 'https://docs-pulse.edna.by/docs/channel',
  [ELinkType.INTEGRATION_PUSH]: 'https://docs-pulse.edna.by/docs/channel',
  [ELinkType.RELEASE]: 'https://docs-pulse.edna.by/blog',
  [ELinkType.ERROR_CODES]:
    'https://docs-pulse.edna.by/docs/api/messages/errorcodes#ошибки-при-получении-статусов-сообщений',
  [ELinkType.WABA_BLOCK]: 'https://docs-pulse.edna.by/docs/channel',
  [ELinkType.MAX_BLOCKING_PROTECTION]: '',
};

const LINKS_KZ: TLinks = {
  [ELinkType.DOCS]: 'https://docs-pulse.edna.kz/',
  [ELinkType.SUPPORT_EMAIL]: 'support@edna.kz',
  [ELinkType.PULSE_API]: 'https://docs-pulse.edna.kz/docs/start/whatis',
  [ELinkType.FBM_VERIFICATION]:
    'https://docs-pulse.edna.kz/docs/additional-info/whatsapp/company-verify',
  [ELinkType.IOS_URGENCY_LEVEL]: 'https://docs-pulse.edna.kz/docs/channel/',
  [ELinkType.INTEGRATION_PUSH]: 'https://docs-pulse.edna.kz/docs/channel/',
  [ELinkType.INTEGRATION_WA]: LINKS_OSK[ELinkType.INTEGRATION_WA],
  [ELinkType.CHANNEL_QUALITY_WA]:
    'https://docs-pulse.edna.kz/docs/additional-info/whatsapp/channel-quality',
  [ELinkType.FB_PUBLIC_TERMS]:
    'https://edna.kz/legal/prepaid/usloviya-podkljucheniya-kanala-whatsapp/',
  [ELinkType.RELEASE]: 'https://docs-pulse.edna.kz/blog',
  [ELinkType.ERROR_CODES]:
    'https://docs-pulse.edna.kz/docs/api/messages/errorcodes#ошибки-при-получении-статусов-сообщений',
  [ELinkType.WABA_BLOCK]: 'https://docs-pulse.edna.kz/docs/additional-info/whatsapp/avoid-block',
  [ELinkType.WA_CHANNEL_VERIFICATION]:
    'https://docs-pulse.edna.kz/docs/additional-info/whatsapp/company-verify',
  [ELinkType.AGENT_DOCS]: LINKS_OSK[ELinkType.AGENT_DOCS],
  [ELinkType.WA_MM_API]:
    'https://edna.kz/news/novyj-uroven-marketinga-v-whatsapp-chto-takoe-mm-api-i-kak-ego-ispolzovat/',
  [ELinkType.WA_MM_API_ACCEPTANCE]:
    'https://docs-pulse.edna.ru/docs/additional-info/whatsapp/mm-api-activation#how-to-enable-marketing-messages-api',
  [ELinkType.WA_BUSINESS_PORTFOLIO]:
    'https://docs-pulse.edna.kz/docs/additional-info/whatsapp/business-portfolio/',
  [ELinkType.SMS_PRICING]: LINKS_OSK[ELinkType.SMS_PRICING],
  [ELinkType.WA_TEMPLATE_MESSAGES]: LINKS_OSK[ELinkType.WA_TEMPLATE_MESSAGES],
  [ELinkType.SIGN_UP_TERMS]: 'https://edna.kz/kz/legal/prepaid/offer/',
  [ELinkType.BROADCASTS_TUTORIAL]: 'https://docs-pulse.edna.kz/docs/broadcast/create-broadcast',
  [ELinkType.TRIGGERS_TUTORIAL]: 'https://docs-pulse.edna.kz/docs/scripts/script-using',
  [ELinkType.CASCADES_TUTORIAL]: 'https://docs-pulse.edna.kz/docs/cascades/createcascade',
  [ELinkType.DIALOGS_TUTORIAL]: 'https://docs-pulse.edna.kz/docs/conversations',
  [ELinkType.MAX_BLOCKING_PROTECTION]: '',
};

const LINKS_BY_RESELLER: Record<EResellerIds, TLinks> = {
  [EResellerIds.OSK_ID]: LINKS_OSK,
  [EResellerIds.MFM_ID]: LINKS_MFM,
  [EResellerIds.PT_ID]: LINKS_PT,
  [EResellerIds.KZ_ID]: LINKS_KZ,
  [EResellerIds.BLR_FIRST_ID]: LINKS_BLR,
  [EResellerIds.BLR_SECOND_ID]: LINKS_BLR,
};

const useEdnaLinks = (resellerId?: EResellerIds): TLinks => {
  const {data: tenant} = useGetTenantDataQuery(undefined, {skip: !!resellerId});

  const targetResellerId = resellerId ?? tenant?.resellerId;

  if (targetResellerId === undefined) {
    return {} as TLinks;
  }

  return LINKS_BY_RESELLER[targetResellerId] ?? {};
};

export {useEdnaLinks, ELinkType};
